// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStorePlaylists = (client) => ({
    /**
     * `POST /store/playlists`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePostStreamingPlaylists
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/playlists", { method: "POST", body, query, headers }),
    /**
     * `POST /store/playlists/:id/items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePostStreamingPlaylistsIdItems
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/[id]/items/route.ts
     */
    createItem: (id, body, query, headers) => client.fetch(buildPath("/store/playlists/:id/items", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/playlists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreDeleteStreamingPlaylistsId
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/store/playlists/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /store/playlists/:id/items/:itemId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreDeleteStreamingPlaylistsIdItemsItemId
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/[id]/items/[itemId]/route.ts
     */
    deleteItem: (id, itemId, body, query, headers) => client.fetch(buildPath("/store/playlists/:id/items/:itemId", [id, itemId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /store/playlists`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetStreamingPlaylists
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/route.ts
     */
    list: (query, headers) => client.fetch("/store/playlists", { method: "GET", query, headers }),
    /**
     * `GET /store/playlists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetStreamingPlaylistsId
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/playlists/:id", [id]), { method: "GET", query, headers }),
    /**
     * `PATCH /store/playlists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePatchStreamingPlaylistsId
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/store/playlists/:id", [id]), { method: "PATCH", body, query, headers }),
    /**
     * `PATCH /store/playlists/:id/items/reorder`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePatchStreamingPlaylistsIdItemsReorder
     * @source packages/medusa-plugin-streaming-media/src/api/store/playlists/[id]/items/reorder/route.ts
     */
    updateItemsReorder: (id, body, query, headers) => client.fetch(buildPath("/store/playlists/:id/items/reorder", [id]), { method: "PATCH", body, query, headers }),
});
//# sourceMappingURL=playlists.js.map